import { controls,grouped } from "../controls";
const cpb = {
label: "Cash Payment Batches",
pageLabel: "Cash Payment Batches",starting: true,url: "autogen",
formActions: { edit: { allow: false },delete:{allow:false} },
pageType: "history",
formTabs:
 {allTabs: [
{ label: "General", uid: "general" },
{label: "Denomination",uid: "denomination"}
]},
filter:[
...controls.displayText({ tab: "filter", label: "Createdby"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "createdby",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.magicDateLabel({ tab: "filter", label: "Updatedat",target: "updatedat"}),
...controls.magicDate({ tab: "filter", name: "updatedat", dateType: "ontype" }),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Total Credits"}),
...controls.floatOnly({ tab: "filter",  placeHolder: "", name: "total_credits",maxlength:21}),
...controls.displayText({ tab: "filter",  label: "",width:"col-sm-2"}),
...controls.checkBox({ tab: "filter",default:true, label: "Active", name: "cpb_active" }),
]
,form:[

            ...grouped.trnsummary(),
            {
              widths: "col-sm-9",
              tab: "general",
              style: { marginTop: 5, border: 0, paddingLeft: 0, paddingRight: 0 },
              direction: 'vertical',
              pagination: { perPage: 30, buttonSize: 'col-sm-2' },
              subComponents: [
              ...grouped.denominationtrn(),{
widths: "col-sm-12",
tab: "general",
title: "Cash Payment Transactions",
subComponents: [

                                        {
                                  widths: "col-sm-9",
                                  tab: "general",
                                  style: { border: 0, paddingLeft: 0, paddingRight: 0 },
                                  direction: 'vertical',
                                  pagination: { perPage: 30, buttonSize: 'col-sm-2' },
                                  subComponents: [
                                      ...controls.displayText({ tab: "general", label: "Account",star:true}),
...controls.oc({ tab: "general", c: "Account", placeHolder: "Account Code",width:'col-sm-3', name: "account_code", isRequired:false,fastpath:"accounts" ,isReadOnly:"edit" }),
...controls.showData({ tab: "general", displaytype: "capital", data: "account_display",width:"col-sm-7"}),
...controls.displayText({ tab: "general", label: "Amount"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "amount",width:'col-sm-3',maxlength:18 ,isReadOnly:"edit" }),
...controls.displayText({ tab: "general", label: "Charges"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "charges",width:'col-sm-3',maxlength:18 ,isReadOnly:"edit" }),
...controls.displayText({ tab: "general", label: "Instrument Number",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "instrument_number",isRequired:false,width:'col-sm-3',maxlength:10 ,isReadOnly:"edit" }),
...controls.magicDateLabel({ tab: "general", label: "Instrument Date",target: "instrument_date",star:true}),
...controls.magicDate({ tab: "general", name: "instrument_date", dateType: "ontype",isRequired:false,width:'col-sm-3' ,isReadOnly:"edit"  }),
...controls.displayText({ tab: "general", label: "Particulars",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "particulars",isRequired:false,width:'col-sm-5',maxlength:10 ,isReadOnly:"edit" }),
...controls.displayText({ tab:"cash_payment_transactions" ,width:"col-sm-12", label: "" }),
...controls.displayText({ tab:"cash_payment_transactions" ,width:"col-sm-4", label: "" }),
...controls.button({
tab:"cash_payment_transactions",
 label: "ADD",
 style: { padding: 0 },
Bcolor: "success",
 onclick: {
  action: "appendToHTMLTable",
  tableNameField: "cash_payment_transactions",
  requiredField: ["account_code","account_display","account_uid","amount","charges","instrument_number","instrument_date","particulars",]
}, width: "col-sm-2"
}),
...controls.button({
tab:"cash_payment_transactions",
 label: "CLEAR",
 style: { padding: 0 },
Bcolor: "warning",
 onclick: {
  action: "clearForm",
  tableNameField: "cash_payment_transactions",
  requiredField: ["account_code","account_display","account_uid","amount","charges","instrument_number","instrument_date","particulars",]
}, width: "col-sm-2"
}),
]},
                                    {
                                      widths: "col-sm-3",
                                      tab: "general",
                                      style: { border: 0, paddingLeft: 0, paddingRight: 0 },
                                      direction: 'vertical',
                                      pagination: { perPage: 30, buttonSize: 'col-sm-2' },
                                      subComponents: [
                                        ...controls.displayImage({name:"acphotos"})
                                      ]
                                    },
                                    {
  tab:"cash_payment_transactions",
inputType: "table",
  tableTitle: "",
  deletable: true,
  editable: true,
  tableHeaders: [
    { label: "Sr", type: "autoinc" },
    { label: "Account Code", field: "account_code"},
    { label: "Account Display", field: "account_display"},
    { label: "Amount", field: "amount"},
    { label: "Charges", field: "charges"},
    { label: "Instrument Number", field: "instrument_number"},
    { label: "Instrument Date", field: "instrument_date", displaytype: "date"},
    { label: "Particulars", field: "particulars"},
  ],
  widths: {
    parent: "col-sm-12",
    children: "col-sm-12"
  },
  name: "cash_payment_transactions"
},
]},

              ]
            },
            grouped.acinfo('general')
            ]
, history:{
perPage: 10,
reportHeader: "Cash Payment Batches",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Createdby",accessor: "createdby",},
{Header: "Updatedat",accessor: "updatedat",type:'date'},
{Header: "Total Credits",accessor: "total_credits",},
{Header: "Cpb Active",accessor: "cpb_active",type:'tick'},
]}};
export default cpb;